import style from './EducationalOnboardingPage.css';
import AppBar from '../../components/shared/AppBar/AppBar';
import NavigationUtils from '../../utils/navigation.utils';
import { useRef, useEffect } from 'preact/hooks';
import { renderIf } from '../../utils/render.utils';
import CarouselListing from '../../components/EducationalOnboarding/CarouselList/CarouselListing';
import useConfig from '../../config/config.context';
import CaasLocalStorageKeys from '../../constants/caas.local.storage.keys';
import Base64Utils from '../../utils/base64.utils';

import GetEducationalOnboarding, {
  EducationalOnboardingType,
} from './EducationalOnboardingProvider';

export default function EducationalOnboardingPage({ type, path }) {
  const carouselItems = GetEducationalOnboarding(
    EducationalOnboardingType.SendMoney,
  );
  const backRef = useRef(null);
  const { config, updateStorage } = useConfig();

  const handleCloseClick = () => {
    if (path === undefined || path === '') {
      return NavigationUtils.endFlow();
    }

    const url = Base64Utils.decode(path);

    return NavigationUtils.navigate(url, true);
  };

  useEffect(() => {
    if (type !== undefined) {
      const navigationComponents =
        config.storage[CaasLocalStorageKeys.NAVIGATION_COMPONENTS] ?? [];
      navigationComponents.push(`eo-${type}`);
      updateStorage(
        CaasLocalStorageKeys.NAVIGATION_COMPONENTS,
        navigationComponents,
      );
    }
  }, []);

  return (
    <>
      <AppBar
        onCloseClick={handleCloseClick}
        className="fixed-bar"
        closeRef={backRef}
      />
      <div className={style.container}>
        {renderIf(
          carouselItems.length,
          <div className={style.content}>
            <CarouselListing
              items={carouselItems}
              onButtonClick={handleCloseClick}
            />
          </div>,
        )}
      </div>
    </>
  );
}
